import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { commandsApi, type ChatCommand } from '@/api/commands.api';

export const commandsKeys = {
  all: ['commands'] as const,
};

export function useCommands() {
  return useQuery({
    queryKey: commandsKeys.all,
    queryFn: () => commandsApi.list(),
  });
}

export function useSaveCommands() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (commands: ChatCommand[]) => commandsApi.replace(commands),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: commandsKeys.all });
      toast.success('Comandos guardados');
    },
    onError: () => toast.error('No se pudo guardar'),
  });
}
